var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRotateCcw = function SvgRotateCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "rotate-ccw_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4v6h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgRotateCcw as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMSA0VjEwSDciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0zLjUxIDE0Ljk5OTlDNC4xNTgzOSAxNi44NDAzIDUuMzg3MzQgMTguNDIwMSA3LjAxMTY2IDE5LjUwMTNDOC42MzU5OCAyMC41ODI1IDEwLjU2NzcgMjEuMTA2NSAxMi41MTU3IDIwLjk5NDRDMTQuNDYzNyAyMC44ODIzIDE2LjMyMjYgMjAuMTQwMSAxNy44MTIxIDE4Ljg3OTdDMTkuMzAxNyAxNy42MTkzIDIwLjM0MTMgMTUuOTA4OSAyMC43NzQyIDE0LjAwNjNDMjEuMjA3MiAxMi4xMDM3IDIxLjAxMDEgMTAuMTExOSAyMC4yMTI2IDguMzMxMDVDMTkuNDE1MiA2LjU1MDE5IDE4LjA2MDUgNS4wNzY3NCAxNi4zNTI4IDQuMTMyNzFDMTQuNjQ1MSAzLjE4ODY4IDEyLjY3NjkgMi44MjUyMSAxMC43NDQ3IDMuMDk3MDdDOC44MTI0NSAzLjM2ODkyIDcuMDIwOTEgNC4yNjEzNyA1LjY0IDUuNjM5OTVMMSA5Ljk5OTk1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";